import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private http = inject(HttpClient);
  private readonly BASE = `${environment.apiUrl}/notifications`;

  private _unreadCount = new BehaviorSubject<number>(0);
  readonly unreadCount$ = this._unreadCount.asObservable();

  private _refresh = new Subject<void>();
  readonly refresh$ = this._refresh.asObservable();

  private _newNotif = new Subject<any>();
  readonly newNotif$ = this._newNotif.asObservable();

  setUnreadCount(n: number) { this._unreadCount.next(n); }
  getUnreadCount(): number  { return this._unreadCount.getValue(); }
  triggerRefresh()          { this._refresh.next(); }
  pushNewNotif(n: any)      { this._newNotif.next(n); }

  getList(page: number, limit: number, is_read?: boolean): Observable<any> {
    const params: Record<string, any> = { page, limit };
    if (is_read !== undefined) params['is_read'] = is_read;
    return this.http.get<any>(this.BASE, { params });
  }

  markAllRead(): Observable<any> {
    return this.http.put<any>(`${this.BASE}/read-all`, {});
  }

  markOneRead(id: string): Observable<any> {
    return this.http.put<any>(`${this.BASE}/${id}/read`, {});
  }
}
